module.exports = __webpack_public_path__ + "static/media/designSystem.000d79f7.png";